import React, { FC, useState } from 'react';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import LegalEntitiesTable, {
  getLegalEntityData,
} from '~/pages/ksa/application/shareholders/components/legalEntities/LegalEntitiesTable';
import { useGetPayload } from '~/controllers/wizard';
import LegalReviewEntityEdit from './LegalReviewEntityEdit';

const LegalEntitiesReviewTableForm: FC<Partial<FormItemInjectedProps<KsaShareholders>>> = (
  props
) => {
  const payload = useGetPayload();
  const shareholders = { shareholders: payload?.shareholders };

  const [editUid, setEditUid] = useState('');
  const openEdit = (uid: string) => {
    setEditUid(uid);
  };
  const closeEdit = () => {
    setEditUid('');
  };

  const legalEntitiesDataSource = getLegalEntityData(shareholders, openEdit);

  return (
    <>
      {editUid && <LegalReviewEntityEdit uid={editUid} onClose={closeEdit} {...props} />}
      <LegalEntitiesTable legalEntities={legalEntitiesDataSource} />
    </>
  );
};

export default LegalEntitiesReviewTableForm;
